import { uniq } from 'lodash';
import { useMemo } from 'react';

import { useLoggedInEmployeeId, useLoggedInUserRoles } from '~/components/Auth';
import { useLegacySalaryHistoricalProposal } from '~/data/proposals/useGetLegacyHistoricalProposals';
import { useSelectedEmployeeId } from '~/hooks/employee/useSelectedEmployeeId';
import { isRoleHRAdmin } from '~/services/Permissions';

import { useSalaryProposalColumns } from '../../common';
import {
  ProposalsHistoryTableLayout,
  SalaryProposalWorkflowTable,
} from '../components';

export const SalaryProposalHistoryTable = () => {
  const roles = useLoggedInUserRoles();
  const isHRAdmin = isRoleHRAdmin(roles);
  const loggedInId = useLoggedInEmployeeId();
  const { selectedEmployeeId: employeeId } = useSelectedEmployeeId();
  const { data } = useLegacySalaryHistoricalProposal({
    employeeId,
  });

  const { rows, employmentIds } = useMemo(() => {
    const rows =
      loggedInId === employeeId && !isHRAdmin
        ? data.filter((item) => item.fSalaryProposalStatus !== 'FAILED')
        : data;

    return { rows, employmentIds: uniq(rows.map((r) => r.fEmplId)) };
  }, [data, loggedInId, employeeId, isHRAdmin]);

  const columns = useSalaryProposalColumns({ employmentIds });

  return (
    <ProposalsHistoryTableLayout
      rows={rows}
      columns={columns}
      employeeId={employeeId}
      proposalWorkflowTable={SalaryProposalWorkflowTable}
    />
  );
};
